<template>
    <div>
        <div>
            <el-row>
                <div class="channel">
                    <div class="title">{{channelTitle}}</div>
                    <!-- <div class="type-tab">
                        <el-tabs  type="card" @tab-click="handleClick" :value="getActiveName(tabArr)" >
                            <el-tab-pane 
                                v-for="(item) in tabArr"   
                                :key="item.themeStyleCode "
                                :label="item.themeStyleName " 
                                :name="item.themeStyleName" >
                                <div class="father">
                                    <PopForm
                                    :popDataitem="item"
                                    @saveChange='saveChange'
                                    ></PopForm>
                                </div>                              
                            </el-tab-pane>
                        </el-tabs>
                    </div> -->
                    <div
                        v-for="(item) in tabArr"   
                        :key="item.themeStyleCode "
                        :label="item.themeStyleName " 
                        :name="item.themeStyleName" 
                    >
                        <PopForm
                        :popDataitem="item"
                        @saveChange='saveChange'
                        ></PopForm>
                    </div>
                </div>
            </el-row>
        </div>        
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import PopForm from './quotaWait-confirmed-pop-form.vue'
    export default {
      name: 'quotaWait-confirmed-pop',
      props: {
        channelForm:{type:Object, default:()=>{} },
        dataForm:{type:Array,default:()=>[]},
      },
      components: {
        PopForm
      },
      data () {
        return {
            tabList:[],
            tabName:'地标',
            childName:'',
            tabArr: [],
            activeName: '',
            tabIndex: '',
            channelTitle:'',
            itemData: '',
            allList:[],
            num: 1,
            num2: 1,
            num3: 1,
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {
        const tab = {index: 0}
        this.handleClick(tab)
      },
      updated () {},
      methods: {
        init () {
            this.getChannelitem()
        },
        getChannelitem () {
            // console.log(this.channelForm,'this.channelForm');
            let code = this.channelForm.themeStyleCode
            let itemList = []
            for (let i = 0; i < this.dataForm.length; i++) {
                if (code === this.dataForm[i].themeDetail.themeStyleCode && this.dataForm[i].curAssignList.length > 0 ) {
                        itemList.push({
                            'themeDetail':this.dataForm[i].themeDetail,
                            // 'gpActivityInfoVOList':this.dataForm[i].gpActivityInfoVOList,
                            'curAssignInfo':this.dataForm[i].curAssignInfo,
                            'subAssignList':this.dataForm[i].subAssignList,
                            'curAssignList':this.dataForm[i].curAssignList
                        })
            }}
            if (itemList.length == 0) {
                return
            }
            this.allList = itemList
            this.getTaball(this.allList)
            let themeStyleName = itemList[0].themeDetail.themeStyleName
            if (themeStyleName) {
                this.channelTitle = this.channelForm.themeChannelEnName + '-' +  themeStyleName  
            }else {
                this.channelTitle = this.channelForm.themeChannelEnName
            }
        },
        getAllList () {
            let itemIndex = []
            for (let item of this.allList) {
                let index = itemIndex.indexOf(item.themeDetail.themeStyleCode)
                if (index === -1) {
                    itemIndex.splice(0,0,item.themeDetail.themeStyleCode)
                    let data = [
                        {
                        'themeLevelCode':item.themeDetail.themeLevelCode,
                        'themeStyleName':item.themeDetail.themeStyleName,
                        'themeStyleCode':item.themeDetail.themeStyleCode,
                        'themeDetail':item.themeDetail,
                        'curAssignInfo':item.curAssignInfo,
                        'subAssignList':item.subAssignList,
                        'curAssignList':item.curAssignList
                        }
                    ]
                    this.tabArr.push(data)
                } else {
                    this.tabArr[index].push(
                        {
                            'themeLevelCode':item.themeDetail.themeLevelCode,
                            'themeStyleName':item.themeDetail.themeStyleName,
                            'themeStyleCode':item.themeDetail.themeStyleCode,
                            'themeDetail':item.themeDetail,
                            'curAssignInfo':item.curAssignInfo,
                            'subAssignList':item.subAssignList,
                            'curAssignList':item.curAssignList
                        }
                    )
                }  
            }
            this.tabList =  this.tabArr.map((item)=>{
                return item.themeStyleName || item[0].themeDetail.themeStyleName
            }).join('、')
        },
        getTaball (arr) {
            let map = {}
            let dest = [];
            for(let i = 0; i < arr.length; i++){
                let ai = arr[i];
                if(!map[ai.themeDetail.themeStyleCode]){
                    dest.push({
                        themeStyleCode: ai.themeDetail.themeStyleCode,
                        themeStyleName: ai.themeDetail.themeStyleName,
                        data: [ai]
                    });
                    map[ai.themeDetail.themeStyleCode] = ai;
                }else{
                    for(let j = 0; j < dest.length; j++){
                        let dj = dest[j];
                        if(dj.themeStyleCode == ai.themeDetail.themeStyleCode){
                            dj.data.push(ai);
                            break;
                        }
                    }
                }
            }
            // console.log(dest,'dest');
            this.tabArr = dest
            this.tabList =  this.tabArr.map((item)=>{
                return item.themeStyleName
            }).join('、')
            return dest
        },
        // 保存变更
        saveChange (item) {
            this.$emit("saveChange",item)
        },
        getActiveName(tabArr) {
            return tabArr[0].themeStyleName
        },
        handleClick(tab) {
            let num = Number(tab.index)
            this.tabIndex = num
        },    
    }
}
</script>
<style lang="scss" scoped>
   
.channel {
    margin-top: 30px;
    .title {
        height: 50px;
        line-height: 50px;
        text-align: left;
        color: #101010;
        font-size: 18px;
        font-weight: 600;
    }
    .channel-type {
        padding: 10px 10px 10px 30px;
        background-color: #FFFFFF;
        color: #101010;
        // border-radius: 8px;
        font-family: SourceHanSansSC-bold;
        font-size: 16px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        display: flex;
        text-align: left;
        .left {
            width: 20%;
        }
    }
    .type-tab {
        margin-top: 20px;
        ::v-deep .el-tabs__item.is-active {
            background-color: #409EFF;
            color: #FFFFFF;
        }
        ::v-deep .el-tabs__item {
            color: #101010;
            background-color: #FFFFFF;
            text-align: center;
            margin-right: 5px;
            min-width: 100px;
            border: none;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            height: 42px;
            padding: 0px !important;
        }
        ::v-deep .el-tabs__nav-scroll {
            border-bottom: 0;
        }
        ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
            border: 0;
            margin-bottom: 0;
        }
        ::v-deep .el-tabs--card>.el-tabs__header {
            border-bottom: 0px solid #E4E7ED;
        }
        ::v-deep .el-tabs__content {
            overflow: hidden;
            position: relative;
            margin-top: -15px;
            background-color: #FFFFFF;
            padding: 20px 0px 0px 0px;
            border-radius: 8px;
            border-top-left-radius: 0px;
        }
    }
}

</style>
